import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { toCents } from "@/utils/numberUtils";
import { UserHasQualificationStatusEnum } from "@altertec_gparn/lib";

export class BulkCreateUserHasQualificationsDto {
  @Expose()
  qualificationId: string;

  @Expose()
  userIds: string[];

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  start: Date;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  effectiveDate: Date;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : null))
  @Expose()
  finishedAt?: Date | null;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  end?: Date;

  @Transform(({ value }) => (value != null ? toCents(value) : value))
  @Expose()
  cost?: number;

  @Transform(({ value }) => (value != null ? toCents(value) : value))
  @Expose()
  internalCost?: number;

  @Expose()
  paidByEmployee?: boolean;

  @Expose()
  invoiceNumber?: string;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : null))
  @Expose()
  invoiceDate?: Date | null;

  @Expose()
  supplierId?: string;

  @Expose()
  subsidized?: boolean;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : null))
  @Expose()
  paymentDate?: Date | null;

  @Transform(({ value }) => (value != null ? toCents(value) : value))
  @Expose()
  subsidyAmount?: number;

  @Transform(({ value }) => (value ? parseAppDate(value, true) : null))
  @Expose()
  subsidyMonth?: Date | null;

  @Expose()
  status?: UserHasQualificationStatusEnum;

  @Expose()
  certified?: boolean;

  @Expose()
  confirmRenewals?: boolean;
}
